import { getCookieConsent } from './cookieConsent'

const TRACKING_IDS = ['G-W5ZK4ZGLFZ', 'GT-PB68RF2']

let analyticsLoaded = false

export function loadAnalytics() {
  if (typeof window === 'undefined' || analyticsLoaded) return
  if (getCookieConsent() !== 'accepted') return

  analyticsLoaded = true

  const firstTrackingId = TRACKING_IDS[0]
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())

  TRACKING_IDS.forEach((trackingId) => {
    window.gtag('config', trackingId, {
      send_page_view: false,
      anonymize_ip: true,
    })
  })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${firstTrackingId}`
  document.head.appendChild(script)

  trackPageView()
}

export function trackPageView(location) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  if (getCookieConsent() !== 'accepted') return

  const loc = location || window.location
  const pagePath = loc.pathname + loc.search + loc.hash
  window.gtag('event', 'page_view', { page_path: pagePath })
}
